import { NavigateFunction } from 'react-router-dom';

type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;
const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;

export const WF_ROOT = env === 'wf' ? '' : '/wf';

export const buildWfPath = (path: string) => {
  if (!WF_ROOT) return path.startsWith('/') ? path : `/${path}`;

  if (path === WF_ROOT || path.startsWith(`${WF_ROOT}/`)) return path;

  return `${WF_ROOT}${path.startsWith('/') ? path : `/${path}`}`;
};

export const wfNavigate = (navigate: NavigateFunction, path: string, replace: boolean = false) =>
  navigate(buildWfPath(path), { replace: replace });
